import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useTranslations } from 'gt-react'
import { ArrowLeft } from 'lucide-react'
import { toast } from 'sonner'
import { LayoutAwareForm } from '@/components/crm/layout-aware-form'
import { Button } from '@/components/ui/button'
import { orpc } from '@/lib/orpcClient'

export const Route = createFileRoute('/crm/leads/new')({
  component: NewLeadPage,
})

function NewLeadPage() {
  const t = useTranslations()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const createMutation = useMutation(
    orpc.crm.leads.create.mutationOptions({
      onSuccess: (result) => {
        toast.success(`${t('crm.lead.entity')} ${t('crm.common.createdAt').toLowerCase()}`)
        queryClient.invalidateQueries({ queryKey: orpc.crm.leads.list.key() })
        const created = result as { id: string }
        navigate({ to: '/crm/leads/$leadId', params: { leadId: created.id } })
      },
      onError: (e) => toast.error(e.message),
    }),
  )

  return (
    <div className="p-6 max-w-3xl mx-auto space-y-4">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" onClick={() => navigate({ to: '/crm/leads' })}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          {t('crm.common.cancel')}
        </Button>
        <h1 className="text-2xl font-bold">{t('crm.lead.newLead')}</h1>
      </div>
      <LayoutAwareForm
        entityKey="lead"
        onSubmit={(value) => createMutation.mutate(value)}
        submitting={createMutation.isPending}
        submitLabel={t('crm.common.create')}
        onCancel={() => navigate({ to: '/crm/leads' })}
      />
    </div>
  )
}
